import { atom } from "recoil";

import { BoutiqueOrderSheetSetRow } from "@/features/order-status/order-sheet-set-row.type";

export const boutiqueOrderSheetSetRowsState = atom<
  BoutiqueOrderSheetSetRow[] | undefined
>({
  key: "BoutiqueOrderSheetSetRow",
  default: undefined,
});

export const boutiqueOrderSheetSetRowsMutateId = atom<number>({
  key: "BoutiqueOrderSheetSetRowMutateId",
  default: 0,
});
